module.exports = __webpack_public_path__ + "img/sample_01.5575c607.jpg";